export const Visitor = {
    id: '0000000',
    userId: '',
    user_id: '',
    token: '',
    avatar: 'logom.png',
    phone: '',
    nickname: 'visitor',
    birthday: '',
    gender: 0,
    hometown: '',
    loginTime: '',
    country: '',
};
